e4.productList = {
    debug: false,
    init: function () {
        e4.productList.bindEvents();
    },
    bindEvents: function () {
        jQuery( '.js-e-productlist' ).on( 'submit', '.js-e-product-form', function ( event ) {
            event.preventDefault();
            e4.productList.products.addToCart( event.target );
        } ).on( 'click', '.js-e-productlist-load-more-products-btn', function ( event ) {
            event.preventDefault();
            e4.productList.products.loadMore( event.target );
        } ).on( 'loaded.e4.jsonpublisher', function ( event, jsonData ) {
            jQuery( event.target ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            e4.productList.toggleLoadMoreButton( event.target, jsonData );
        } );
    },
    toggleLoadMoreButton: function ( domNode, jsonData ) {
        if ( parseInt( jQuery( domNode ).closest( '.js-e-productlist' ).data( 'json-src-get-params' ).PageSize ) < e4.data.getObjectValueByPropertyPath( 'list.productCount', jsonData ) ) {
            e4.productList.showLoadMoreButton( domNode );
        }
        else {
            e4.productList.hideLoadMoreButton( domNode );
        }
    },
    showLoadMoreButton: function ( domNode ) {
        jQuery( domNode ).closest( '.js-e-productlist' ).find( '.js-e-productlist-load-more-products-btn' ).removeClass( 'd-none' );
    },
    hideLoadMoreButton: function ( domNode ) {
        jQuery( domNode ).closest( '.js-e-productlist' ).find( '.js-e-productlist-load-more-products-btn' ).addClass( 'd-none' );
    },
    products: {
        addToCart: function ( domForm ) {
            e4.util.disableAllSubmitButtonsInForm( domForm );
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                var jForm = jQuery( domForm ),
                    objValidator = jForm.validate( {
                        submitHandler: function () {
                            e4.product.addToCart( domForm ).done( function () {
                                e4.util.enableAllSubmitButtonsInForm( domForm );
                            } );
                        }
                    } );
                if ( jForm.valid() === true ) {
                    objValidator.settings.submitHandler.call( objValidator, objValidator.currentForm );
                }
                else {
                    e4.util.enableAllSubmitButtonsInForm( domForm );
                }
            } );
        },
        loadMore: function ( domNode ) {
            var jProductList = jQuery( domNode ).closest( '.js-e-productlist' ),
                jsonSrcGetParams = jProductList.data( 'json-src-get-params' );
            console.log( domNode, jsonSrcGetParams );
            jProductList.data( 'json-src-get-params', jQuery.extend( {}, jsonSrcGetParams, {
                PageSize: e4.settings.ecom.productList.loadMoreCount
            } ) );
            jProductList.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            console.log( jProductList.data( 'json-src-get-params' ) );
            e4.jsonpublisher.reload( jProductList.get( 0 ) );
        }
    }
};
